import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function isOutput() {
  return true;
}
function log() {
  if (isOutput()) {
    var _console, _context;
    for (var _len = arguments.length, msg = new Array(_len), _key = 0; _key < _len; _key++) {
      msg[_key] = arguments[_key];
    }
    (_console = console).log.apply(_console, _concatInstanceProperty(_context = ['[kd-table]']).call(_context, msg));
  }
}
function warn() {
  if (isOutput()) {
    var _console2, _context2;
    for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      msg[_key2] = arguments[_key2];
    }
    (_console2 = console).warn.apply(_console2, _concatInstanceProperty(_context2 = ['[kd-table]']).call(_context2, msg));
  }
}
function error() {
  var _console3, _context3;
  for (var _len3 = arguments.length, msg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    msg[_key3] = arguments[_key3];
  }
  (_console3 = console).error.apply(_console3, _concatInstanceProperty(_context3 = ['[kd-table]']).call(_context3, msg));
}
function table() {
  if (isOutput()) {
    var _console4, _context4;
    for (var _len4 = arguments.length, msg = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      msg[_key4] = arguments[_key4];
    }
    (_console4 = console).table.apply(_console4, _concatInstanceProperty(_context4 = ['[kd-table]']).call(_context4, msg));
  }
}
export default {
  log: log,
  warn: warn,
  error: error,
  table: table
};